export const fdefContractAssignedClerk = {
  formdefinition: [
    {
      control: "input",
      name: "vertrag",
      label: "Vertrag",
      cols: "12",
      disabled: "true",
    },
    {
      control: "autocomplete",
      name: "sachbearbeiter_id",
      label: "Sachbearbeiter",
      valid: "isNotEmpty(item)",
      multiple: false,
      cols: "12",
      get_api: {
        target: "options",
        method: "get",
        endpoint:
          '"data/vertrags/"+getValue("id")+"/assignable-clerks?id_type=internal"',
        eval_endpoint: true,
      },
    },
  ],
  transformOut: [],
};
